<template>
  <v-col md="3" sm="6" class="border-right border-left">
    <div class="shadow bordered rounded-lg p-4">
      <div v-if="loading" class="text-center">
        <v-progress-circular
            indeterminate
            color="primary"
            size="40"
        ></v-progress-circular>
      </div>
      <div v-else class="d-flex justify-space-between w-full">
        <div>Queue Connection</div>
        <div >
          <div class="status-container" v-if="status"><div class="status-dot active"></div>Active</div>
          <div class="status-container" v-else><div class="status-dot inactive"></div>Inactive</div>
        </div>
      </div>
    </div>
  </v-col>
</template>
<script>
export default {
  data() {
    return {
      status: 0,
      loading: false,
    }
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    this.stopAutoFetch();
  },
  methods: {
    startAutoFetch() {
      if(!this.fetchInterval){
        this.fetchInterval = setInterval(() => {
          this.getData(); // Fetch every 3 seconds
        }, 240000); // 3000ms = 3 seconds
      }
    },
    stopAutoFetch() {
      if (this.fetchInterval) {
        clearInterval(this.fetchInterval); // Clears the interval
        this.fetchInterval = null; // Reset the interval ID
      }
    },
    getData() {
      this.loading = true; // Start loader
      this.$http
          .get(`monitoring/queue-connection`)
          .then((response) => {
            if (response.status == 200) {
              this.status = response.data.status;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.loading = false; // Stop loader
            this.startAutoFetch();
          });
    },
  }

}
</script>

<style scoped>
.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.status-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}


.status-dot.active {
  background-color: green;
  animation: pulse 1.5s infinite;
}

.status-dot.inactive {
  background-color: red;
    animation: fastPulse 0.5s infinite;
}

/* Pulsing effect */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 255, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(0, 255, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 255, 0, 0);
  }
}
@keyframes fastPulse {
  0% {
    box-shadow: 0 0 0 0 #ff0000;
  }
  70% {
    box-shadow: 0 0 0 15px rgba(0, 255, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 255, 0, 0);
  }
}

</style>